class DebouncedFunction {
  constructor(element, event = 'scroll.debouncer resize.debouncer', callback) {
    this.tick = false;
    this.element = element;
    this.bind(event);
    this.callback = callback;
  }
  bind(event) {
    if (this.bound) {
      return;
    }

    this.element.on(event, () => {
      if(!this.tick) {
        // Fallback to the update function if rAF is not supported
        window.requestAnimationFrame ? this.req() : this.checkCallback();
      }
    });
    this.bound = true;
  }
  unbind(event) {
    this.element.off(event);
    this.bound = false;
  }
  req() {
    if(!this.tick) {
      requestAnimationFrame(() => this.checkCallback());
    }
    this.tick = true;
  }
  checkCallback() {
    this.callback();
    this.tick = false;
  }
}

export default DebouncedFunction;
